/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EBooleanSearchTypes } from './EBooleanSearchTypes';
import {
    EBooleanSearchTypesFromJSON,
    EBooleanSearchTypesFromJSONTyped,
    EBooleanSearchTypesToJSON,
} from './EBooleanSearchTypes';

/**
 * 
 * @export
 * @interface EBooleanSearchTypesBooleanNullableCombinableCriteria
 */
export interface EBooleanSearchTypesBooleanNullableCombinableCriteria {
    /**
     * 
     * @type {EBooleanSearchTypes}
     * @memberof EBooleanSearchTypesBooleanNullableCombinableCriteria
     */
    searchMode?: EBooleanSearchTypes;
    /**
     * 
     * @type {boolean}
     * @memberof EBooleanSearchTypesBooleanNullableCombinableCriteria
     */
    value?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EBooleanSearchTypesBooleanNullableCombinableCriteria
     */
    secondaryValue?: boolean | null;
}

/**
 * Check if a given object implements the EBooleanSearchTypesBooleanNullableCombinableCriteria interface.
 */
export function instanceOfEBooleanSearchTypesBooleanNullableCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EBooleanSearchTypesBooleanNullableCombinableCriteriaFromJSON(json: any): EBooleanSearchTypesBooleanNullableCombinableCriteria {
    return EBooleanSearchTypesBooleanNullableCombinableCriteriaFromJSONTyped(json, false);
}

export function EBooleanSearchTypesBooleanNullableCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EBooleanSearchTypesBooleanNullableCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EBooleanSearchTypesFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function EBooleanSearchTypesBooleanNullableCombinableCriteriaToJSON(value?: EBooleanSearchTypesBooleanNullableCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EBooleanSearchTypesToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

